import { Trans, useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import type { FC } from 'react';
import React from 'react';

import type { SvgProps } from '@/components/Sprite/Icon';
import { Icon } from '@/components/Sprite/Icon';
import { cn } from '@/utils';

interface FeaturesListItemProps extends SvgProps {
  title: string;
  description: string;
  className?: string;
}
export const FeaturesListItem: FC<FeaturesListItemProps> = ({
  title,
  description,
  name,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cn('flex md:flex-col gap-5 md:gap-6', className)}>
      <span className="flex size-max items-center justify-center rounded-full bg-blue-50 p-3 md:p-4">
        <Icon name={name} className="size-6 text-blue-500 md:size-8" />
      </span>
      <div>
        <p className="body2-bold tracking-[0.2px] text-blue-900">{t(title)}</p>
        <p className="body3 mt-1 font-[425] text-grey-800">
          <Trans
            i18nKey={description}
            t={t}
            components={{
              blueText: (
                <Link
                  href={t('faq_page.question_5.link')}
                  className="text-blue-500"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};
